var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.ready)?_c('div',[_c('b-loading',{attrs:{"is-full-page":"","can-cancel":false}})],1):_vm._e(),_vm._v(" "),_c('div',{attrs:{"id":"app"}},[_c('div',[_c('Nuxt')],1)]),_vm._v(" "),_c('Style')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }